export default __webpack_public_path__ + "static/media/violationImage.3e01edf1.png";